import { FC } from "react";
import { FormikProps } from "formik";
import { GetOfferParticipant_getOfferParticipant } from "_graphql/visal/queries/__generated__/GetOfferParticipant";
import { Info } from "lucide-react";
import { TextInput } from "components/core";
import _ from "lodash";

export interface AddParticipantFormProps {
  form: FormikProps<any>;
  participant?: GetOfferParticipant_getOfferParticipant | null | undefined;
  type?: "reinsurer" | "broker";
}

const AddParticipantForm: FC<AddParticipantFormProps> = ({
  form,
  type = "reinsurer",
  participant,
}) => {
  return (
    <div className="space-y-6 divide-y divide-gray-200">
      <div>
        <div className="grid grid-cols-2 gap-2">
          {type === "reinsurer" ? (
            <div className="col-span-3">
              <div className="">
                <div className="grid grid-cols-3 gap-6 mt-2">
                  <div className="col-span-3">
                    <TextInput
                      postText={`Out of ${form?.values?.expected}`}
                      id={"percentage"}
                      type="number"
                      label="Percentage"
                      required
                      placeholder="Eg. 10"
                      {...form}
                    />
                  </div>
                  {participant?.reinsurer?.kava_premium_member
                    ?.membership_status === "ACTIVE" && (
                    <div className="col-span-3 bg-yellow-50 border border-yellow-200 rounded text-yellow-800 p-1 mt-1 flex justify-start items-center gap-2">
                      <Info className="w-5 h-5 flex-shrink-0" />
                      <p className="text-xs">
                        The share you add to{" "}
                        {participant?.reinsurer?.re_company_name}, will be
                        adjusted based on the premium membership limits
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="col-span-3">
                <div className="">
                  <div className="grid grid-cols-3 gap-6 mt-2">
                    <div className="col-span-3">
                      <TextInput
                        id={"share_percentage"}
                        type="number"
                        label="Share percentage"
                        required
                        placeholder="Eg. 10"
                        {...form}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-span-3">
                <div className="">
                  <div className="grid grid-cols-3 gap-6 mt-2">
                    <div className="col-span-3">
                      <TextInput
                        id={"admin_percentage"}
                        type="number"
                        label="Admin Percentage"
                        required
                        placeholder="Eg. 10"
                        {...form}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddParticipantForm;
